"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    logger: ()=>logger
});
const domain_id_service_js_namespaceObject = require("../domain-id/domain-id.service.js");
const external_comon_js_namespaceObject = require("./comon.js");
const cloudDebuggerKey = '__cloud_debugger__';
const sessionFlag = Boolean(external_comon_js_namespaceObject.hasWindow && window.sessionStorage.getItem(cloudDebuggerKey));
const shouldConsole = ()=>{
    if (sessionFlag || external_comon_js_namespaceObject.hasWindow && window[cloudDebuggerKey] || domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('local')) return true;
    return false;
};
const logger = {
    log () {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++)data[_key] = arguments[_key];
        if (shouldConsole()) console.log('[INFO]', ...data);
    },
    info () {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++)data[_key] = arguments[_key];
        if (shouldConsole()) console.info('[INFO]', ...data);
    },
    warn () {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++)data[_key] = arguments[_key];
        if (shouldConsole()) console.warn('[WARN]', ...data);
    },
    error () {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++)data[_key] = arguments[_key];
        if (shouldConsole()) console.error('[ERROR]', ...data);
    }
};
exports.logger = __webpack_exports__.logger;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "logger"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
